module.exports = __webpack_public_path__ + "img/ta.424ea212.png";